<template>
  <div>
    <!-- Page Sidebar Start-->
    <div class="page-sidebar">
      <div class="main-header-left d-none d-lg-block">
        <div class="logo-wrapper">
          <router-link to="/"
            ><img
              class="blur-up lazyloaded"
              src="../../assets/images/dashboard/sablior-2-150x52.png"
              alt=""
          /></router-link>
          
        </div>
      </div>
      <div class="sidebar custom-scrollbar">
        <div class="sidebar-user text-center">
          <!-- Photo du profil : cliquable pour en ajouter / changer une
               (masqué pour le super-admin, dont le profil n'est pas
               modifiable côté API). -->
          <div
            class="sidebar-avatar"
            :class="{ 'avatar-clickable': canEditPhoto }"
            @click="pickPhoto"
          >
            <img
              v-if="profile.photoURL"
              class="img-60 rounded-circle lazyloaded blur-up"
              :src="profile.photoURL"
              alt="#"
            />
            <!-- Pas de photo de profil : icône anonyme par défaut -->
            <div v-else class="avatar-anonymous rounded-circle">
              <feather type="user"></feather>
            </div>
            <span class="avatar-badge" v-if="canEditPhoto">
              <feather type="camera"></feather>
            </span>
            <input
              ref="photoInput"
              type="file"
              accept="image/*"
              class="photo-input"
              @change="onPhotoSelected"
            />
          </div>
          <!-- Nom du profil -->
          <h6 class="mt-3 f-14">{{ profileName }}</h6>
          <!-- Nom du site : uniquement dans le tableau de bord du site -->
          <p class="sidebar-site mb-0" v-if="siteName">{{ siteName }}</p>
        </div>
        <ul
          class="sidebar-menu"
          id="myDIV"
        >
          <li
            v-for="(menuItem, index) in menuItems"
            :key="index"
            :class="{ active: menuItem.active }"
          >
            <!-- Sub -->
            <a
              href="javascript:void(0)"
              class="sidebar-header"
              v-if="menuItem.type == 'sub'"
              @click="onSubClick(menuItem, index)"
            >
             <feather :type="menuItem.icon"> </feather>
              <span>
                {{ $t(menuItem.title) }}
              </span>

              <span
                :class="'badge badge-pill badge-' + menuItem.badgeType"
                v-if="menuItem.badgeType"
                >{{ $t(menuItem.badgeValue) }}</span
              >
              <i
                class="fa fa-angle-right pull-right"
                v-if="menuItem.children"
              ></i>
            </a>
            <router-link
              :to="menuItem.path"
              class="sidebar-header"
              v-if="menuItem.type == 'link'"
              router-link-exact-active
            >
              <feather :type="menuItem.icon" class="middle"></feather>
              <span>
                {{ $t(menuItem.title) }}
                <span
                  :class="'badge badge-' + menuItem.badgeType + ' ml-3'"
                  v-if="menuItem.badgeType"
                  >{{ $t(menuItem.badgeValue) }}</span
                >
              </span>
              <i
                class="fa fa-angle-right pull-right"
                v-if="menuItem.children"
              ></i>
            </router-link>
            <!--</span>
            </span>-->
            <!-- External Link -->
            <a
              :href="menuItem.path"
              class="sidebar-header"
              v-if="menuItem.type == 'extLink'"
              @click="setNavActive(menuItem, index)"
            >
              <feather :type="menuItem.icon" class="middle"></feather>
              <span>
                {{ $t(menuItem.title) }}
                <span
                  :class="'badge badge-' + menuItem.badgeType + ' ml-3'"
                  v-if="menuItem.badgeType"
                  >{{ $t(menuItem.badgeValue) }}</span
                >
              </span>
              <i
                class="fa fa-angle-right pull-right"
                v-if="menuItem.children"
              ></i>
            </a>
            <!-- External Tab Link -->
            <a
              :href="menuItem.path"
              target="_blank"
              class="sidebar-header"
              v-if="menuItem.type == 'extTabLink'"
              @click="setNavActive(menuItem, index)"
            >
              <feather :type="menuItem.icon" class="middle"></feather>
              <span>
                {{ $t(menuItem.title) }}
                <span
                  :class="'badge badge-' + menuItem.badgeType + ' ml-3'"
                  v-if="menuItem.badgeType"
                  >{{ $t(menuItem.badgeValue) }}</span
                >
              </span>
              <i
                class="fa fa-angle-right pull-right"
                v-if="menuItem.children"
              ></i>
            </a>
            <!-- 2nd Level Menu -->
            <ul
              class="sidebar-submenu"
              v-if="menuItem.children"
              :class="{ 'menu-open': menuItem.active }"
            >
              <li
                v-for="(childrenItem, index) in menuItem.children"
                :key="index"
                :class="{ active: childrenItem.active }"
              >
                <!-- Sub -->
                <a
                  href="javascript:void(0)"
                  v-if="childrenItem.type == 'sub'"
                  @click="setNavActive(childrenItem, index)"
                >
                  <i class="fa fa-circle"></i>
                  {{ $t(childrenItem.title) }}
                  <span
                    :class="
                      'badge badge-' + childrenItem.badgeType + ' pull-right'
                    "
                    v-if="childrenItem.badgeType"
                    >{{ $t(childrenItem.badgeValue) }}</span
                  >
                  <i
                    class="fa fa-angle-right pull-right"
                    v-if="childrenItem.children"
                  ></i>
                </a>
                <!-- Link -->
                <!--{{ childrenItem.children }}-->
                <!--{{ childrenItem.path }}-->
                <span
                  v-for="(item, index) in childrenItem.children"
                  :key="index"
                >
                </span>

                <router-link
                  :to="childrenItem.path"
                  v-if="childrenItem.type == 'link'"
                  router-link-exact-active
                >
                  <i class="fa fa-circle"></i>
                  {{ $t(childrenItem.title) }}
                  <span
                    :class="
                      'badge badge-' + childrenItem.badgeType + ' pull-right'
                    "
                    v-if="childrenItem.badgeType"
                    >{{ $t(childrenItem.badgeValue) }}</span
                  >
                  <i
                    class="fa fa-angle-down pull-right"
                    v-if="childrenItem.children"
                  ></i>
                </router-link>
                <!-- External Link -->
                <a
                  :href="childrenItem.path"
                  v-if="childrenItem.type == 'extLink'"
                >
                  <i class="fa fa-circle"></i>
                  {{ $t(childrenItem.title) }}
                  <span
                    :class="
                      'badge badge-' + childrenItem.badgeType + ' pull-right'
                    "
                    v-if="childrenItem.badgeType"
                    >{{ $t(childrenItem.badgeValue) }}</span
                  >
                  <i
                    class="fa fa-angle-down pull-right"
                    v-if="childrenItem.children"
                  ></i>
                </a>
                <!-- External Tab Link -->
                <a
                  :href="childrenItem.path"
                  target="_blank"
                  v-if="childrenItem.type == 'extTabLink'"
                >
                  <i class="fa fa-circle"></i>
                  {{ childrenItem.title }}
                  <span
                    :class="
                      'badge badge-' + childrenItem.badgeType + ' pull-right'
                    "
                    v-if="childrenItem.badgeType"
                    >{{ $t(childrenItem.badgeValue) }}</span
                  >
                  <i
                    class="fa fa-angle-down pull-right"
                    v-if="childrenItem.children"
                  ></i>
                </a>
                <!-- 3rd Level Menu -->
                <ul class="sidebar-submenu" v-if="childrenItem.children">
                  <li
                    v-for="(childrenSubItem, index) in childrenItem.children"
                    :key="index"
                  >
                    <!-- Link -->
                    <router-link
                      :to="childrenSubItem.path"
                      v-if="childrenSubItem.type == 'link'"
                      router-link-exact-active
                    >
                      <i class="fa fa-circle"></i>
                      {{ $t(childrenSubItem.title) }}
                      <span
                        :class="
                          'badge badge-' +
                            childrenSubItem.badgeType +
                            ' pull-right'
                        "
                        v-if="childrenSubItem.badgeType"
                        >{{ $t(childrenSubItem.badgeValue) }}</span
                      >
                      <i
                        class="fa fa-angle-right pull-right"
                        v-if="childrenSubItem.children"
                      ></i>
                    </router-link>
                    <!-- External Link -->
                    <a
                      :href="childrenSubItem.path"
                      v-if="childrenSubItem.type == 'extLink'"
                    >
                      <i class="fa fa-circle"></i>
                      {{ $t(childrenSubItem.title) }}
                      <span
                        :class="
                          'badge badge-' +
                            childrenSubItem.badgeType +
                            ' pull-right'
                        "
                        v-if="childrenSubItem.badgeType"
                        >{{ $t(childrenSubItem.badgeValue) }}</span
                      >
                      <i
                        class="fa fa-angle-right pull-right"
                        v-if="childrenSubItem.children"
                      ></i>
                    </a>
                    <!-- External Tab Link -->
                    <a
                      :href="childrenSubItem.path"
                      target="_blank"
                      v-if="childrenSubItem.type == 'extTabLink'"
                    >
                      <i class="fa fa-circle"></i>
                      {{ childrenSubItem.title }}
                      <span
                        :class="
                          'badge badge-' +
                            childrenSubItem.badgeType +
                            ' pull-right'
                        "
                        v-if="childrenSubItem.badgeType"
                        >{{ childrenSubItem.badgeValue }}</span
                      >
                      <i
                        class="fa fa-angle-right pull-right"
                        v-if="childrenSubItem.children"
                      ></i>
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
    <!-- Page Sidebar Ends-->
  </div>
</template>
<script>
import { mapState } from "vuex";
import Cookies from 'js-cookie';
import { entitlementState, hasPaid } from "../../utils/entitlement";
import UserAuth from "../../auth/index.js";
import firebase from "@/utils/firestore-shim";
import { uploadUrl, uploadHeaders } from "../../utils/imageUpload";
export default {
  name: "Sidebar",
  data() {
    return {
      width: 0,
      height: 0,
      // Profil affiché en haut de la sidebar (nom + photo), relu depuis
      // le localStorage « userinfo » (voir refreshProfile()).
      profile: { displayName: "", email: "", photoURL: "" },
      uploadingPhoto: false,
      // Section « Super Admin » (menu réactif) : construite seulement si le
      // compte connecté est super-admin. Vivre dans `data` rend le toggle du
      // sous-menu réactif (setNavActive mute item.active), contrairement à un
      // computed qui renverrait des objets non observés.
      superAdminMenu: []
    };
  },
  computed: {
    ...mapState({
      mainMenuItems: state => state.menu.data
    }),
    // Droits d'usage du compte (réactif : voir utils/entitlement.js).
    entitlement() {
      return entitlementState.entitlement;
    },
    // Abonnement actif (payé) ou super-admin : accès complet à l'admin.
    paid() {
      return hasPaid(this.entitlement);
    },
    // Le super-admin ne peut pas modifier son profil côté API : on ne lui
    // propose donc pas d'ajouter une photo.
    isSuperAdmin() {
      return Boolean(this.entitlement && this.entitlement.superadmin);
    },
    canEditPhoto() {
      return !this.isSuperAdmin;
    },
    // Nom affiché du profil (à défaut, l'e-mail).
    profileName() {
      return this.profile.displayName || this.profile.email || "Admin";
    },
    // Nom du site : affiché uniquement dans le tableau de bord du site
    // (une boutique est sélectionnée). Ailleurs, aucun site n'est affiché.
    siteName() {
      if (this.$route.path !== "/dashboard/site") return "";
      return Cookies.get("hostCookie") || "";
    },
    // Entrées de menu du compte : toujours visibles, y compris sans
    // abonnement (un compte non payé doit pouvoir gérer son profil et
    // souscrire). L'état actif suit la route courante.
    accountMenuItems() {
      const path = this.$route.path;
      return [
        {
          path: "/account/profile",
          title: "Profile",
          icon: "user",
          type: "link",
          active: path === "/account/profile"
        },
        {
          path: "/account/subscription",
          title: "Subscription",
          icon: "credit-card",
          type: "link",
          active: path === "/account/subscription"
        }
      ];
    },
    // Super-admin : la sidebar n'affiche QUE la section Super Admin
    // (Overview, Subscribers, Payments, Plans, Stores, Activity) ; les menus
    // Dashboard/Store/Shop/Blog et les entrées Profil/Abonnement sont masqués
    // (la déconnexion reste disponible dans l'en-tête).
    // Autre compte : menu complet (Dashboard, Store, Shop, Blog) réservé aux
    // comptes payants, suivi des entrées de compte. Sans abonnement actif,
    // seules Profil et Abonnement sont affichées.
    menuItems() {
      if (this.isSuperAdmin) return this.superAdminMenu;
      const main = this.paid ? this.mainMenuItems : [];
      return main.concat(this.accountMenuItems);
    }
  },
  created() {
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
    this.refreshProfile();
    this.buildSuperAdminMenu();
    if (this.width < 991) {
      // this.layout.settings.sidebar.type = "default";
    }
  },
  watch: {
    // setProfile() (connexion, en-tête, page Profil, upload de la photo)
    // met à jour l'entitlement réactif : on en profite pour relire le
    // profil affiché (nom, photo) et rester synchronisé.
    entitlement() {
      this.refreshProfile();
      this.buildSuperAdminMenu();
    },
    // Reconstruit la section Super Admin à chaque navigation : le sous-menu
    // reste ouvert sur les pages /admin et l'entrée active suit la route.
    $route() {
      this.buildSuperAdminMenu();
    }
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.menuItems.filter(items => {
      if (items.path === this.$route.path)
        this.$store.dispatch("menu/setActiveRoute", items);
      if (!items.children) return false;
      items.children.filter(subItems => {
        if (subItems.path === this.$route.path)
          this.$store.dispatch("menu/setActiveRoute", subItems);
        if (!subItems.children) return false;
        subItems.children.filter(subSubItems => {
          if (subSubItems.path === this.$route.path)
            this.$store.dispatch("menu/setActiveRoute", subSubItems);
        });
      });
    });
  },
  methods: {
    onSubClick(item, index) {
      // The "Dashboard" menu item has no children: clicking it opens the dashboard
      // of the selected store (site panel) when one is chosen, otherwise the global view.
      if (!item.children && item.title == "Dashboard") {
        this.dashboardClick(item.title);
        return;
      }
      this.setNavActive(item, index);
    },
    dashboardClick(title) {
      if (title == "Dashboard") {
        const host = Cookies.get("hostCookie");
        const target = host ? "/dashboard/site" : "/";
        if (this.$route.path !== target) {
          this.$router.push(target);
        }
      }
    },
    setNavActive(item) {
      this.$store.dispatch("menu/setNavActive", item);
    },
    handleResize() {
      this.width = window.innerWidth - 310;
    },
    // Relit le profil (nom, e-mail, photo) depuis le localStorage « userinfo ».
    refreshProfile() {
      const p = UserAuth.getProfile() || {};
      this.profile = {
        displayName: p.displayName || "",
        email: p.email || "",
        photoURL: p.photoURL || ""
      };
    },
    // Construit (ou vide) la section « Super Admin » selon les droits du
    // compte. Un seul item dépliable (type 'sub') avec 6 entrées (type 'link') ;
    // l'état actif suit la route courante.
    buildSuperAdminMenu() {
      if (!this.isSuperAdmin) {
        this.superAdminMenu = [];
        return;
      }
      const path = this.$route.path;
      const onAdmin = String(path).indexOf("/admin") === 0;
      const child = (p, title) => ({
        path: p,
        title: title,
        type: "link",
        active: p === path
      });
      this.superAdminMenu = [
        {
          title: "Super Admin",
          icon: "shield",
          type: "sub",
          active: onAdmin,
          children: [
            child("/admin/overview", "Overview"),
            child("/admin/subscribers", "Subscribers"),
            child("/admin/payments", "Payments"),
            child("/admin/plans", "Plans"),
            child("/admin/stores", "Stores"),
            child("/admin/events", "Activity")
          ]
        }
      ];
    },
    // Ouvre le sélecteur de fichier pour ajouter / changer la photo.
    pickPhoto() {
      if (!this.canEditPhoto || this.uploadingPhoto) return;
      if (this.$refs.photoInput) this.$refs.photoInput.click();
    },
    // Téléverse l'image choisie (POST /api/uploads), l'enregistre sur le
    // profil (PATCH /auth/profile) puis recharge le profil complet.
    async onPhotoSelected(event) {
      const input = event.target;
      const file = input.files && input.files[0];
      if (!file) return;
      if (!/^image\//.test(file.type)) {
        this.notify("Please choose an image file.", "error");
        input.value = "";
        return;
      }
      this.uploadingPhoto = true;
      try {
        const user = UserAuth.getProfile() || {};
        const folder = "avatars/" + String(user.id || "me").replace(/[^a-zA-Z0-9_-]/g, "-");
        const form = new FormData();
        form.append("folder", folder);
        form.append("file", file, file.name || "avatar");
        const res = await fetch(uploadUrl, {
          method: "POST",
          headers: uploadHeaders(),
          body: form
        });
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.error || ("Error " + res.status));
        if (!data || !data.url) throw new Error("No URL returned by the server.");
        await firebase.api.patch("/auth/profile", { photoURL: data.url });
        const fresh = await firebase.auth().fetchProfile();
        UserAuth.setProfile(fresh);
        this.refreshProfile();
        this.notify("Profile photo updated.", "success");
      } catch (e) {
        this.notify((e && e.message) || "Upload failed.", "error");
      } finally {
        this.uploadingPhoto = false;
        input.value = "";
      }
    },
    notify(message, type) {
      if (this.$toasted) {
        this.$toasted.show(message, {
          theme: "bubble",
          position: "bottom-right",
          type: type || "info",
          duration: 3000
        });
      }
    },
  }
};
</script> 
<style scoped>
/* Le panneau du menu remplit son conteneur (le div.page-sidebar de Body.vue)
   et se déplace avec lui. Avant, il était en position fixe, accroché à la
   fenêtre pendant que son conteneur glissait : le navigateur mobile ne
   redessinait alors plus son contenu, qui n'apparaissait qu'après un
   défilement de la page. */
.page-wrapper .page-body-wrapper .page-sidebar {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
}

/* Photo du profil (haut de la sidebar) + pastille « appareil photo » */
.sidebar-avatar {
  position: relative;
  display: inline-block;
}
.sidebar-avatar.avatar-clickable {
  cursor: pointer;
}
.sidebar-avatar .avatar-badge {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #4050f6;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
}
.sidebar-avatar .avatar-badge svg {
  width: 12px;
  height: 12px;
}
/* Avatar par défaut : icône anonyme (quand aucune photo de profil) */
.sidebar-avatar .avatar-anonymous {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e9edf2;
  color: #8a94a6;
}
.sidebar-avatar .avatar-anonymous svg {
  width: 30px;
  height: 30px;
}
/* Input fichier caché, déclenché par clic sur la photo */
.sidebar-avatar .photo-input {
  display: none;
}
.sidebar-site {
  font-size: 12px;
  color: #898989;
  word-break: break-all;
}
</style>
